export class FullMapModel {
    id = '';
    id_finca = '';
    finca = '';
    sector?: string;
    id_sector = '';
    id_parcela = '';
    parcela_id = '';
    id_cultivo = '';
    id_cultivo_legacy = '';
    id_variedad = '';
    id_variedad_legacy = '';
    parcela_nombre = '';
    sigpac = '';
    superficie = '';
    cod_provincia = '';
    municipio = '';
    poligono = '';
    recinto = '';
    parcela = '';
    cultivo = '';
    cultivo_legacy = '';
    variedad = '';
    coordenadas = '';
    color = '';
    id_usuario = '';
    id_cliente?: string;
};